<template>
  <div>
    <wc-data-box
      :title='toolbarData.title'
      :titleIcon='toolbarData.icon'
      :titleIconColor='toolbarData.color'
      :showEdit='!wo.archived && !wo.office_complete'
      :mini='mini'
      @edit='edit'
    >
      <wc-two-column-table :items='mustDoData'></wc-two-column-table>
      <v-divider class='mb-1'></v-divider>
      <span class='ml-4 grey--text subtitle'>Considerations:</span><br>
      <v-card-text :style='(wo.scheduling_considerations && !isLoading && schedule) ? "border: 1px red solid;" : ""'>
        {{ wo.scheduling_considerations }}
      </v-card-text>
    </wc-data-box>

    <scheduling-considerations-dialog
      :woCopy='woCopy'
      :showDialog='showEditDialog'
      @update='update'
      @cancel='cancel'
    ></scheduling-considerations-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import SchedulingConsiderationsDialog from './SchedulingConsiderationsDialog';

export default {
  name: 'scheduling-considerations',
  props: {
    wo: {
      required: true
    },
    mini: {
      required: false,
      type: Boolean,
      default: false
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false
    },
    schedule: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showEditDialog: false,
    mustDoOptions: [
      { value: 0, text: 'Normal' },
      { value: 1, text: 'Should do today' },
      { value: 2, text: 'Must do' }
    ],
    woCopy: {}
  }),
  computed: {
    toolbarData () {
      return {
        title: this.schedule ? 'W.O. Scheduling Considerations' : 'Scheduling Considerations',
        icon: 'mdi-calendar-cursor',
        color: 'primary'
      }
    },
    mustDoData () {
      let table = [
        { text: 'Estimated Time on Site', value: this.wo.tos + ' mins'},
        { text: 'Must do status', value: this.mustDoOptions.find(m => m.value === this.wo.priority).text },
        { text: 'Apt. Date', value: this.$options.filters.shortDate(this.wo.apt_date) }
      ]
      if (!this.wo.apt_end) {
        table.push({ text: 'Apt. Time', value: this.wo.apt_time ? this.$options.filters.time(this.wo.apt_time) : "" })
      } else {
        table.push({ text: 'Apt. window', value: this.$options.filters.time(this.wo.apt_time) + " - " + this.$options.filters.time(this.wo.apt_end)})
      }
      if (this.wo.apt_time || !!this.wo.priority)
        table.push({ text: 'Apt. notes:', value: this.wo.apt_notes ?  this.wo.apt_notes : '' })

        table.push({ text: 'Fieldcrew call ahead?', value: this.wo.call_mins_ahead ? (this.wo.call_mins_ahead + ' mins') : '' })
      
      if (this.wo.call_mins_ahead) {
        table.push({ text: 'Call ahead notes:', value: this.wo.call_mins_ahead_notes ? this.wo.call_mins_ahead_notes : ''})
      }
      if (this.wo.timeline) {
        table.unshift({ text: 'Timeline', value: this.wo.timeline ?  this.wo.timeline : '' })
        //TODO timeline display
      }
      return table;
    }
  },
  methods: {
    edit () {
      this.woCopy = _.cloneDeep(this.wo)
      this.showEditDialog = true
    },
    update (wo) {
      this.$emit('update', wo);
      this.showEditDialog = false;
    },
    cancel () {
      this.showEditDialog = false;
    }
  },
  components: {
    'scheduling-considerations-dialog': SchedulingConsiderationsDialog,
  }
}
</script>
